/**
 * @generated SignedSource<<6ecfa0ef7fcb5bac720da19d61dd8fb9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PLUCategoryItem_PLUCategory$data = {
  readonly color: string;
  readonly id: string;
  readonly title: string;
  readonly " $fragmentType": "PLUCategoryItem_PLUCategory";
};
export type PLUCategoryItem_PLUCategory$key = {
  readonly " $data"?: PLUCategoryItem_PLUCategory$data;
  readonly " $fragmentSpreads": FragmentRefs<"PLUCategoryItem_PLUCategory">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PLUCategoryItem_PLUCategory",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    }
  ],
  "type": "PLUCategory",
  "abstractKey": null
};

(node as any).hash = "69f1e04bdcf0dbdff8070c18c67e09e7";

export default node;
